<template>
  <div class="time">{{ timeStr }}</div>
</template>

<script>
import moment from "moment";
moment.locale("zh-cn");
// 设置星期名weekdays
export default {
  name: "Page",
  components: {},
  data() {
    return {
      timeStr: moment().format("YYYY.MM.DD HH:mm"),
    };
  },
  mounted() {
    // const second = moment().second();
    // this.timer = setTimeout(() => {
      // clearTimeout(this.timer2);
      this.timeStr = moment().format("YYYY.MM.DD HH:mm");
      this.time2 = setInterval(() => {
        this.timeStr = moment().format("YYYY.MM.DD HH:mm");
      }, 1000);
    // }, (59 - second) * 1000);
  },
  unmounted() {
    // clearInterval(this.timer);
    clearTimeout(this.timer2);
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
